export { EmbeddedFaqItem } from './EmbeddedFaqItem';
export type { EmbeddedFaqItemProps } from './EmbeddedFaqItem';
